// extracted by mini-css-extract-plugin
export default {"container":"index_container__lmIfG","image":"index_image__JWQFf","text":"index_text__Ds556"};